module.exports = __webpack_public_path__ + "img/icon-viber.b6a47169.svg";